import axios from 'axios'
import ResponseHandler from './response-handler'
import qs from 'qs';

let requestHandler = function(type, url, data, callback, config) {
    this.url = url;
    this.callback = callback;
    this.method = "get";

    if(getApp.$store.state.user_info){
        data.current_team_id = getApp.$store.state.user_info.current_team_id;
    }

    if (type === "GET") {
        data = _.extend({params: data}, config);
    } else if (type === "POST") {
        this.method = "post";
        // Do not stringify FormData
        if (!(data instanceof FormData)) {
            data = qs.stringify(data);  // Ref https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format
        }
    } else if (type === "PUT") {
        this.method = "put";
    }

    axios[this.method](url, data, config)
        .then(response => {
            new ResponseHandler(response.data, callback);
        })
        .catch(error => {
            console.log('requestHandler.catch', error);
            if (callback.complete) {
                callback.complete();
            }
            if (!(error instanceof axios.Cancel)) {
                if (callback.error) {
                    callback.error(error);
                } else {
                    window.getApp.$emit('NETWORK_ERROR');
                }
            }
        });
};

const RequestHandler = {
    Get: function(url, data, callback, config){
        new requestHandler("GET", url, data, callback, config);
    },
    Post: function(url, data, callback, config) {
        new requestHandler("POST", url, data, callback, config);
    },
    Put: function (url, data, callback, config) {
        new requestHandler("PUT", url, data, callback, config);
    }
};

export default RequestHandler